module.exports = __webpack_public_path__ + "img/green-tick.d6864f91.svg";